import React, { useState } from "react";
import IconPdf from "./IconPdf";
import CaretRight from "./CaretRight";
import IconDownload from "./IconDownload";
import IconImage from "./IconImage";
import IconZip from "./IconZip";
import IconLock from "./IconLock";
import DownloadModal from "./DownloadModal";

const ResourceTile = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const { title, viewLink, files, id, documentType } = props.resource;
  const isGated = documentType?.isGated || false;
  const isViewLinkPdf = viewLink && viewLink.toLowerCase().endsWith('.pdf');

  const getBaseUrl = () => {
    const resourceContainer = document.querySelector('[data-resources]');
    if (resourceContainer) {
      const resourcesUrl = resourceContainer.getAttribute('data-resources');
      if (resourcesUrl) {
        try {
          const url = new URL(resourcesUrl, window.location.origin);
          return url.pathname.replace('/api', '');
        } catch (e) {
          console.error('Error parsing resources URL:', e);
        }
      }
    }
    
    const currentPath = window.location.pathname;
    if (currentPath.includes('/resources/')) {
      const pathParts = currentPath.split('/');
      const resourcesIndex = pathParts.indexOf('resources');
      return pathParts.slice(0, resourcesIndex + 1).join('/');
    }
    
    return '/resources';
  };

  const handleDownloadClick = (file, e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isGated) {
      setSelectedFile({
        url: file.url || file.link,
        name: file.name || file.filename,
        resourceId: id,
        resourceTitle: title
      });
      setShowModal(true);
    } else {
      const link = document.createElement('a');
      link.href = file.url || file.link;
      link.download = file.name || file.filename || '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleViewClick = (e) => {
    if (isGated && isViewLinkPdf) {
      e.preventDefault();
      e.stopPropagation();
      
      setSelectedFile({
        url: viewLink,
        name: title + '.pdf',
        resourceId: id,
        resourceTitle: title
      });
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedFile(null);
  };

  const getFileIcon = (extension) => {
    switch (extension) {
      case "zip":
        return <IconZip />;
      case "pdf":
        return <IconPdf />;
      case "jpg":
      case "jpeg":
        return <IconImage />;
      default:
        return <IconDownload />;
    }
  };

  const getButtonIcon = (extension) => {
    if (isGated) {
      return <IconLock />;
    }
  
    switch (extension) {
      case "zip":
        return <IconZip />;
      case "pdf":
        return <IconPdf />;
      case "jpg":
      case "jpeg":
        return <IconImage />;
      default:
        return <IconDownload />;
    }
  };

  return (
    <>
      <div className="tabs__body__content__cad resourceTile">
        <div className="tabs__cad__left resourceTile__left">
          <div className="resourceTile__image">
            {files.length > 0 && getFileIcon(files[0]['extension'])}
          </div>

          <div className="tabs__cad__name resourceTile__name">
            <p>{title}</p>
          </div>
        </div>
        
        <div className="tabs__cad__right resourceTile__right">
          {!!viewLink && (
            isGated && isViewLinkPdf ? (
              <button
                onClick={handleViewClick}
                className="tabs__cad__view resourceTile__view flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity bg-transparent border-0 p-0 font-inherit text-inherit"
                type="button"
              >
                <p>View</p>
                <CaretRight />
              </button>
            ) : (
              <a
                href={viewLink}
                target="_blank"
                rel="noopener noreferrer"
                className="tabs__cad__view resourceTile__view"
              >
                <p>View</p>
                <CaretRight />
              </a>
            )
          )}

          {files.map((file, index) => (
            <button
              key={index}
              onClick={(e) => handleDownloadClick(file, e)}
              className="tabs__cad__download resourceTile__download flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity bg-transparent border-0 p-0 font-inherit text-inherit"
              type="button"
              aria-label={`${isGated ? 'Request access to' : 'Download'} ${file.name || 'file'}`}
              title={isGated ? 'Click to request access' : 'Click to download'}
            >
              {getButtonIcon(file.extension)}
            </button>
          ))}
        </div>
      </div>
      
      {isGated && (
        <DownloadModal
          showModal={showModal}
          selectedFile={selectedFile}
          onClose={handleCloseModal}
          basePath={getBaseUrl()}
        />
      )}
    </>
  );
};

export default ResourceTile;